import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1665ab4a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "periodontal-map__header"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "periodontal-map__title" }, "Пародонтальная карта", -1))
const _hoisted_3 = { class: "periodontal-map__header" }
const _hoisted_4 = {
  key: 0,
  class: "periodontal-map__title"
}
const _hoisted_5 = { class: "periodontal-map__header--right-side" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" *У рецессии и глубины зондирования "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" для ввода двузначного числа зажмите Shift ")
], -1))

import { computed, ref } from 'vue'
import { WPeriodontalReportCreation } from '@/widgets/WPeriodontalReportCreation'
import { EPeriodontalMapTable } from '@/entities/EPeriodontalMapTable'
import { EPeriodontalGraphic } from '@/entities/EPeriodontalGraphic'
import { PeriodontalReportType } from '@/shared/types'
import { useRoute } from 'vue-router'
import { useOrganizationModules } from '@/shared/composables'

interface Props {
  previousData: PeriodontalReportType
  data: PeriodontalReportType
}


export default /*#__PURE__*/_defineComponent({
  props: {
    previousData: null,
    data: null
  },
  setup(__props: any) {



const { organizationModules } = useOrganizationModules()
const route = useRoute()

const isCreationDialogVisible = ref(false)

const isPreviewMode = computed(() => route.query['view-mode'] === '1')

const handleOpenCreationDialog = () => {
  if (organizationModules.value.indexOf('periodontology') > -1) {
    isCreationDialogVisible.value = !isCreationDialogVisible.value
  }
}

return (_ctx: any,_cache: any) => {
  const _component_icon_template = _resolveComponent("icon-template")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([{ 'periodontal-map--preview': _unref(isPreviewMode) }, "periodontal-map"])
  }, [
    (!_unref(isPreviewMode))
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _hoisted_2,
          _createVNode(_component_icon_template, {
            class: _normalizeClass([{
          'periodontal-map__header-icon__disable':
            _unref(organizationModules).indexOf('periodontology') <= -1,
        }, "periodontal-map__header-icon"]),
            height: "32",
            name: "open-dialog",
            width: "32",
            onClick: handleOpenCreationDialog
          }, null, 8, ["class"])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_unref(EPeriodontalMapTable), {
      columns: __props.data?.firstFacialData.getData(),
      class: "periodontal-map__table"
    }, null, 8, ["columns"]),
    _createVNode(_unref(EPeriodontalGraphic), {
      "facial-side-data": __props.data?.firstFacialDiagram,
      "facial-side-previous-data": __props.previousData?.firstFacialDiagram,
      "is-upper-teeth": true,
      "tongue-side-data": __props.data?.firstTongueDiagram,
      "tongue-side-previous-data": __props.previousData?.firstTongueDiagram,
      class: "periodontal-map__chart"
    }, null, 8, ["facial-side-data", "facial-side-previous-data", "tongue-side-data", "tongue-side-previous-data"]),
    _createVNode(_unref(EPeriodontalMapTable), {
      columns: __props.data?.firstTongueData.getData(),
      class: "periodontal-map__table-last",
      "is-reverse": ""
    }, null, 8, ["columns"]),
    _createVNode(_unref(EPeriodontalMapTable), {
      columns: __props.data?.secondTongueData.getData(),
      class: "periodontal-map__table"
    }, null, 8, ["columns"]),
    _createVNode(_unref(EPeriodontalGraphic), {
      "facial-side-data": __props.data?.secondTongueDiagram,
      "facial-side-previous-data": __props.previousData?.secondTongueDiagram,
      "is-upper-teeth": false,
      "tongue-side-data": __props.data?.secondFacialDiagram,
      "tongue-side-previous-data": __props.previousData?.secondFacialDiagram,
      class: "periodontal-map__chart",
      "is-reverse": ""
    }, null, 8, ["facial-side-data", "facial-side-previous-data", "tongue-side-data", "tongue-side-previous-data"]),
    _createVNode(_unref(EPeriodontalMapTable), {
      columns: __props.data?.secondFacialData.getData(),
      "is-reverse": ""
    }, null, 8, ["columns"]),
    _createVNode(_component_el_dialog, {
      modelValue: isCreationDialogVisible.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((isCreationDialogVisible).value = $event)),
      "show-close": false,
      class: "periodontal-map__dialog",
      width: "90%"
    }, {
      header: _withCtx(({ close }) => [
        _createElementVNode("div", _hoisted_3, [
          (!_unref(isPreviewMode))
            ? (_openBlock(), _createElementBlock("p", _hoisted_4, " Пародонтальная карта "))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createVNode(_component_icon_template, {
              class: "periodontal-map__header-icon",
              height: "32",
              name: "close-dialog",
              width: "32",
              onClick: close
            }, null, 8, ["onClick"])
          ])
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_unref(WPeriodontalReportCreation), {
          visible: isCreationDialogVisible.value,
          onClose: handleOpenCreationDialog
        }, null, 8, ["visible"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 2))
}
}

})